export default __webpack_public_path__ + "static/media/list_user_icon.901f290c.svg";